module.exports = __webpack_public_path__ + "img/meta.31582086.png";